import { IButton } from "../../../../common/contextmenu"

export const DELETE_ACTION = "DeleteItemAction"

export const findPrimaryButtons = (buttons: IButton[]): IButton[] =>
    buttons.filter((button) => !button.inOptionalMenu)

export const findOptionalStandardButtons = (buttons: IButton[]): IButton[] =>
    buttons.filter(
        (button) =>
            button.inOptionalMenu &&
            button.id != DELETE_ACTION &&
            !button.isCustom,
    )

export const findOptionalCustomButtons = (buttons: IButton[]): IButton[] =>
    buttons.filter(
        (button) =>
            button.inOptionalMenu &&
            button.id != DELETE_ACTION &&
            button.isCustom,
    )

export const findDeleteButton = (buttons: IButton[]): IButton | null =>
    buttons.find((button) => button.id === DELETE_ACTION) ?? null
